const upperFirst = require('mn-utils/upperFirst');
const formatTime = require('mn-utils/formatTime');
const generatePDF = require('../../../../../../../utils/generatePDF');
const formatNumCurrency = require('../../../../../../../utils/formatNumCurrency');

module.exports = (data) => {
  const {
    transactionKind,
    retailerName,
    paymentId,
    currencyTitle,
    currencyAmount,
    currencyCode,
    cryptoCurrencyAmount,
    cryptoCurrencyCode,
    network,
    feeCode,
    retailerFeeAmount,
    customerFeeAmount,
    timeOfTransaction,
    hash,
    email,
    status,
  } = data;

  return generatePDF([
    ['Transaction type', transactionKind],
    ['Retailer name', retailerName],
    ['Payment ID', paymentId],
    ['Transaction hash', hash],
    [currencyTitle, currencyAmount ? `${formatNumCurrency(currencyAmount)} ${currencyCode}` : '-'],
    ['Amount (crypto)', cryptoCurrencyAmount ? `${cryptoCurrencyAmount} ${cryptoCurrencyCode}` : '-'],
    // [
    //     'Exchange rate',
    //     rateAmount
    //       ? `1 ${currencyCode} = ${formatNumCurrency(rateAmount)} ${fiatCode}`
    //       : '-',
    // ],
    ['Network', network ? upperFirst(network) : '-'],
    ['Retailer Fee', retailerFeeAmount ? `${retailerFeeAmount} ${feeCode}` : '-'],
    ['Customer Fee', customerFeeAmount ? `${customerFeeAmount} ${feeCode}` : '-'],
    [
      'Transaction date and time',
      timeOfTransaction
        ? formatTime(timeOfTransaction, '{dddd} {mmmm} {dd}, {yyyy} {HH}:{MM}')
        : '-',
    ],
    ['Customer email', email || '-'],
    {separator: true},
    ['Status', upperFirst(status)],
  ]);
};
